module.exports = __webpack_public_path__ + "static/media/Workday_Step2d_Image5.40219276.jpg";